class PlayerMatchesController {
  constructor(
    PlayersFactory,
    ReportsFactory,
    $rootScope,
    $filter,
    $stateParams
  ) {
    "ngInject";
    const vm = this;

    let $translate = $filter("translate");

    vm.rootScope = $rootScope;

    vm.playerId = $stateParams.id;

    vm.$onInit = () => {
      let params = {
        include: "matches",
      };
      PlayersFactory.getOne(vm.playerId, params).then((response) => {
        vm.gridOptions.data = response.data.matches;
      });
    };

    vm.gridOptions = {
      paginationPageSizes: [50, 100, 150],
      paginationPageSize: 50,
      enableSorting: true,
      enableColumnMenus: false,
      enableFiltering: true,
      columnDefs: [
        {
          field: "matchSortName",
          name: $translate("NAME"),
          enableFiltering: true,
        },
        {
          field: "leagueSortName",
          name: $translate("LEAGUE"),
          enableFiltering: false,
        },
        {
          field: "matchDate",
          name: $translate("DATE"),
          enableFiltering: false,
          width: "120",
        },
        {
          field: "teamName",
          name: $translate("TEAM"),
          enableFiltering: false,
        },
        {
          field: "total_score",
          name: $translate("SCORE"),
          enableFiltering: false,
          width: "80",
        },
        {
          field: "actions",
          enableFiltering: false,
          name: $translate("ACTIONS"),
          headerCellClass: "text-center",
          cellTemplate:
            "" +
            "<div " +
            'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
            '<div class="buttons">' +
            '<button class="btn btn-sm btn-info" translate ' +
            'ng-click="grid.appScope.vm.report(row.entity.match_id)">' +
            "PRINT</button> " +
            "</div>" +
            "</div>",
          width: "130",
        },
      ],
    };

    vm.report = (matchId) => {
      const tabWindowId = window.open("about:blank", "_blank");
      ReportsFactory.playerMatchQualification(matchId, vm.playerId).then(
        (response) => {
          let file = new Blob([response.data], { type: "application/pdf" });
          tabWindowId.location.href = window.URL.createObjectURL(file);
        }
      );
    };
  }
}

export default PlayerMatchesController;



// WEBPACK FOOTER //
// ./client/app/components/players/playerProfile/playerMatches/playerMatches.controller.js